// eslint-disable-next-line import/prefer-default-export
import * as https from 'https';
// import Zntry from '@zn-collect/monitor';
// import { pointTools , traceClick} from '@/utils/point';

/**
 * 上报pv、页面停留时长
 */
// eslint-disable-next-line import/prefer-default-export
export const sendMonitorData = function (store, http) {
  const getFlushingData = function () {
    const flushingList = store.state.tabs.flushingList && [...store.state.tabs.flushingList];
    if (!flushingList || !flushingList.length) return [];
    return flushingList;
  };

  const triggerView = (flushingList) => {
    const datas = getFlushingData();
    function getParams(index) {
      return {
        page_sid: datas[datas.length - index].page_sid || '',
        menu_name: datas[datas.length - index].title,
        url: datas[datas.length - index].path,
        object_id: datas[datas.length - index].object_id,
        page_code: datas[datas.length - index].page_code,
        menu_code:datas[datas.length - index].menu_code,
        referer: datas[datas.length - index].referer,
        }
    }

    if(datas.length > 1) {
      // traceClick({
      //   event_type: 'page_view',
      //   content: {
      //     action: 'end',
      //    ...getParams(2)
      //   }
      // })
      // traceClick({
      //   event_type: 'page_view',
      //   content: {
      //     action: 'start',
      //     ...getParams(1)
      //   }
      // })
    }else {
      // traceClick({
      //   event_type: 'page_view',
      //   content: {
      //     action: 'start',
      //     ...getParams(1)
      //   }
      // })
    }
}
  document.addEventListener('visibilitychange', () => {
    // const data = getFlushingData();
    // console.log('this.$store.state.', data);
    // if (!data) return;
    // sendReport(data);
    // if (document.visibilityState === 'hidden') {
    //   const data = getFlushingData();
    //   if (!data) return;
    //   // 最小化触发
    //   console.error('浏览器被关闭了visibilitychange')
    //   // sendReport(data);
    // }
    triggerView()

  });
  window.addEventListener('pagehide', (event) => { // 页面隐藏
    if (!event.persisted) {
      const datas = getFlushingData();
      if (!datas) return;
      // traceClick({
      //   event_type: 'page_view',
      //   content: {
      //     action: 'end',
      //     page_sid: datas[datas.length - 1].page_sid,
      //     menu_name: datas[datas.length - 1].title,
      //     url: datas[datas.length - 1].path,
      //     }
      // })

    }
  }, false);
};
